import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Stepper, { Step, StepLabel, StepContent } from 'material-ui/Stepper';
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';
import Input, { InputLabel } from 'material-ui/Input';
import { MenuItem } from 'material-ui/Menu';
import { FormControl, FormHelperText } from 'material-ui/Form';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';
import Select from 'material-ui/Select';

let id = 0;
function createData(rating, userbase) {
  id += 1;
  return { id, rating, userbase};
}

class Q5 extends Component {

  constructor(props){
    super(props);

    this.state = {
      lowest: 7,
      highest: 10,
      data:[
        {"value": "Everyone","percentage":"100.00%"},
        {"value": "No Entry 3A","percentage":"0.50%"},
        {"value": "No Answer","percentage":"12.90%"},
        {"value": "High School and Above","percentage":"86.58%"},
        {"value": "Some College or Above","percentage":"73.44%"},
        {"value": "Associate Degree or Above","percentage":"52.30%"},
        {"value": "Bachelor Degree or Above","percentage":"39.44%"},
        {"value": "Graduate Degree or Above","percentage":"14.29%"},
        {"value": "PHD / Post Doctoral","percentage":"0.86%"},
      ],
    };
  }

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render(){
    const { classes, theme, location } = this.props;

    return(
      <div className={classes.root}>
        <Typography>The following is a distribution of our users education level:</Typography>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.alignment} numeric>Education Level</TableCell>
              <TableCell className={classes.alignment} numeric>User %</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.data.map(n => {
              return (
                <TableRow key={n.id}>
                  <TableCell className={classes.alignment}>{n.value}</TableCell>
                  <TableCell className={classes.alignment} numeric>{n.percentage}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <div className={classes.buttonNext}>
          <Button raised onClick={() => this.props.changeRoute("/console/search/create_new_search/six_basic_filters/question5")} color="primary" align="center" className={classes.button}>Go Back</Button>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
    };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    changeRoute: (url) => dispatch(push(url)),
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Q5)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/CreateNewSearch/scenes/SixBasicFilters/scenes/Distribution/Q5/index.js